/** @format */

import MvnoOperation from '../../interfaces/platform/MvnoOperation';
import SetClientDefault from './SetClientDefault';

export default class ClientSubscrChangeMsisdn extends SetClientDefault {
    constructor(operation: MvnoOperation) {
        super(operation);
        let l = 1;
    }
}
